import { ethers } from "ethers";
import ABI_Arbitrum from "../../abi/ABI_Arbitrum";
import ABI_V3 from "../../abi/ABI_V3";
import ABI_Test from "../../abi/ABI_Test";
import privateCheckJson from "./private-check.json";

let NETWORKS = {};
if (privateCheckJson["isPrivate"]) {
  try {
    var app_networks = require("../../private/app_networks");
    NETWORKS = app_networks.default;
  } catch (err) {}
}

let noTestnets = false;
try {
  var productionCheckJson = require("./production-check.json");
  if (productionCheckJson["isProduction"]) {
    noTestnets = true;
  }  
} catch (err) {}

if (!noTestnets) {
  NETWORKS[80001] = {
    testnet: true,
    version: 1,
    chainId: "0x13881",
    chainIdDec: 80001,
    chainName: "Polygon Testnet",
    contract: {
      abi: ABI_V3,
      address: "0xfb95a8a5A226Fd9207844c2142E3d3dfa59e58D8",
      houseEdgeMinimumAmount: ethers.BigNumber.from("1000000000000000"),
      minJackpotBet: ethers.BigNumber.from("10000000000000000"),
      jackpotFee: ethers.BigNumber.from("1000000000000000"),
      minBet: ethers.BigNumber.from("10000000000000000"),
      maxAmount: ethers.BigNumber.from("300000000000000000000000"),
    },
    ui: {
      gradient: "linear-gradient(73.28deg, #8247E5 6.51%, #6027C0 88.45%);",
      decimals: 4,
      betInput: 0.01,
      steps: 0.001,
      menuIcon: "/img/logos/polygon-transparent.svg",
      menuIcon2: "/img/logos/polygon.svg",
      curIconUrl: "/img/logos/polygon.svg",
      symbol: "MATIC",
      explorerUrl: "https://mumbai.polygonscan.com",
    },
    wallet_addEthereumChain: {
      chainId: "0x13881",
      rpcUrls: ["https://matic-mumbai.chainstacklabs.com/"],
      chainName: "Polygon Testnet",
      nativeCurrency: { name: "Matic", decimals: 18, symbol: "MATIC" },
      blockExplorerUrls: ["https://mumbai.polygonscan.com"],
    },
  };

  NETWORKS[421613] = {
    testnet: true,
    version: 1,
    chainId: "0x66EED",
    chainIdDec: 421613,
    chainName: "Arbitrum Testnet",
    contract: {
      abi: ABI_V3,
      address: "0xb64847f69a25B92B88F47B0AC2ec4Ae04c3693BD",
      // address: "0x702DB36666F21fa6ec8Ba08fBAf0b78F624D635A",
      houseEdgeMinimumAmount: ethers.BigNumber.from("300000000000000"),
      minJackpotBet: ethers.BigNumber.from("10000000000000000"),
      jackpotFee: ethers.BigNumber.from("1000000000000000"),
      minBet: ethers.BigNumber.from("10000000000000000"),
      maxAmount: ethers.BigNumber.from("300000000000000000000000"),
    },
    ui: {
      gradient: "linear-gradient(86.38deg, #28A0F0 3.92%, #0678C4 99.17%);",
      decimals: 3,
      betInput: 0.001,
      steps: 0.001,
      menuIcon: "/img/logos/arbitrum-transparent.svg",
      menuIcon2: "/img/logos/arbitrum-transparent.svg",
      curIconUrl: "/img/logos/ethereum.svg",
      symbol: "ETH",
      explorerUrl: "https://goerli.arbiscan.io",
    },
    wallet_addEthereumChain: {
      chainId: "0x66EED",
      rpcUrls: ["https://goerli-rollup.arbitrum.io/rpc"],
      chainName: "Arbitrum Nitro Rollup Testnet",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
      blockExplorerUrls: ["https://goerli.arbiscan.io/"],
    },
  };
  NETWORKS[11155111] = {
    testnet: true,
    version: 1.5,
    chainId: "0xAA36A7",
    chainIdDec: 11155111,
    chainName: "Sepolia Testnet",
    contract: {
      abi: ABI_Test,
      address: "0x7dBE97160A58602a68dECceAC038f67a147F4408",
      // address: "0x702DB36666F21fa6ec8Ba08fBAf0b78F624D635A",
      houseEdgeMinimumAmount: ethers.BigNumber.from("300000000000000"),
      minJackpotBet: ethers.BigNumber.from("10000000000000000"),
      jackpotFee: ethers.BigNumber.from("1000000000000000"),
      minBet: ethers.BigNumber.from("10000000000000000"),
      maxAmount: ethers.BigNumber.from("300000000000000000000000"),
    },
    ui: {
      gradient: "linear-gradient(86.38deg, #28A0F0 3.92%, #0678C4 99.17%);",
      decimals: 3,
      betInput: 0.001,
      steps: 0.001,
      menuIcon: "/img/logos/arbitrum-transparent.svg",
      menuIcon2: "/img/logos/arbitrum-transparent.svg",
      curIconUrl: "/img/logos/ethereum.svg",
      symbol: "ETH",
      explorerUrl: "https://sepolia.etherscan.io",
    },
    wallet_addEthereumChain: {
      chainId: "0xAA36A7",
      rpcUrls: [
        "https://snowy-cosmological-pallet.ethereum-sepolia.quiknode.pro/c889b77902ec827a8c8f1112d677fcad884f8571/",
      ],
      chainName: "Sepolia Testnet",
      nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
      blockExplorerUrls: ["https://sepolia.etherscan.io"],
    },
  };
}
export default NETWORKS;
